<div class="row container-form-list">
    <div class="col-12">
        <div class="card">
            <div class="card-header">
                <h6 class="card-title">
                    Selecione as naturezas de vendas vinculadas a esta unidade de negócio
                </h6>
            </div>
            <div class="table-responsive">
                <table class="table table-striped table-hover table-bordered">
                    <thead>
                        <tr>
                            <th class="col-delete"></th>
                            <th class="col-natureza-venda">Natureza de Venda</th>
                            <th class="col-situacao text-center">Situação</th>
                            <th class="col-cotacao-item-formulario">Formulário Cotação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let entity of entities; let i = index">
                            <td class="col-delete">
                                <a class="btn btn-link" (click)="delete(i)">
                                    <i class="far fa-trash-alt" aria-hidden="true"></i>
                                </a>
                            </td>
                            <td class="col-natureza-venda">
                                <sgt-natureza-venda-typeahead [(ngModel)]="entity.naturezaVenda" name="naturezaVenda_{{i}}" id="naturezaVenda_{{i}}"
                                    #naturezaVenda="ngModel" #naturezaVendaTypeahead [ngControl]="naturezaVenda"
                                    [situacao]="naturezaVendaSituacaoAtiva"
                                    [dropup]="i > 5"
                                    (entitySelected)="onChangeNaturezaVenda(entity, $event)" (clearEntity)="onChangeNaturezaVenda(entity, null)">
                                </sgt-natureza-venda-typeahead>
                            </td>
                            <td class="col-situacao text-center">
                                <span class="badge badge-success" *ngIf="entity.naturezaVenda?.situacao === 1">Ativa</span>
                                <span class="badge badge-danger" *ngIf="entity.naturezaVenda?.situacao === 2">Inativa</span>
                            </td>
                            <td class="col-cotacao-item-formulario">
                                <select class="form-control" name="cotacaoItemFormulario_{{i}}" id="cotacaoItemFormulario_{{i}}"
                                    [ngModel]="entity.cotacaoItemFormulario || ''" (ngModelChange)="entity.cotacaoItemFormulario = $event ? $event : null"
                                    [autofocus]="true">
                                    <option value="">Nenhum...</option>
                                    <option *ngFor="let itemFormularioCotacao of itensFormulariosCotacao" [ngValue]="itemFormularioCotacao.id">{{itemFormularioCotacao.nome}}</option>
                                </select>
                            </td>
                        </tr>
                        <tr *ngIf="entities.length === 0" class="no-record">
                            <td class="text-center" colspan="4">
                                <i class='fas fa-info' aria-hidden='true'></i> Nenhum registro encontrado
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="card-footer">
                <button type="button" class="btn btn-primary btn-sm" (click)="insert()">
                    <i class="fas fa-plus" aria-hidden="true"></i> Adicionar Natureza de Venda
                </button>
            </div>
        </div>
    </div>
</div>
